// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import env from './configs/env';
// vuex 配置
import store from './vuex/store';
import App from './App'
import router from './router'
Vue.config.productionTip = false

require('./jslib/verify-code.min');

window.$imgUrl = env.qnImgDomain;


ElementUi.Dialog.props.closeOnClickModal.default = false; // 修改 el-dialog 默认点击遮照为不关闭
Vue.use(ElementUi, {
  size: 'medium'
});


/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js